import * as React from 'react';
import { Grid } from '@mui/material';
import ReportData from '../components/ReportData';

function ReportGroup({
    dataReportGroup
}) {
    return (
        <>
            <Grid container spacing={2} style={{ marginTop: '30px' }}>
                <ReportData
                    dataReportGroup={dataReportGroup}
                />
            </Grid>
        </>
    )
}
export default ReportGroup;